import classnames from 'classnames';

import { translation, TranslatedComponent } from '@hh.ru/front-static-app';

import styles from 'src/components/Badge/badge.less';

export enum BadgeKind {
    New = 'new',
    Beta = 'beta',
}

const MAP_KIND_TO_CSS_CLASS = {
    [BadgeKind.New]: styles.badgeNew,
    [BadgeKind.Beta]: styles.badgeBeta,
};

const TrlKeys = {
    new: 'statportal.badge.new',
    beta: 'statportal.badge.beta',
};

const Badge: TranslatedComponent<{ kind: BadgeKind }> = ({ kind, trls }) => {
    return (
        <span
            className={classnames(styles.badge, {
                [MAP_KIND_TO_CSS_CLASS[kind]]: kind,
            })}
        >
            {trls[TrlKeys[kind]]}
        </span>
    );
};

export default translation(Badge);
